import { Outlet } from 'react-router-dom'

export default function TrialOnboardingOutlet() {
  return <Outlet />
}
